<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                  <sidebar></sidebar>
                </el-aside>
                <el-main>
                   <div class="tips" v-if="isTag == true">您还没有完成资质审核，还不能发布产品等其他信息，请先完成资质审核</div>
                   <contTitle :class="[isTag == true?'m-t-30':'']" :obj="obj" :contTitle="contTitle"></contTitle>
                   <companySide class="mt-20"  :isButton="false"></companySide> 
                   <div class="mt-30">
                       <!-- <paletteBar :paletteObj="paletteObj"></paletteBar> -->
                       <contTitle class="mt-30" :obj="obj" :contTitle="contTitle1"></contTitle>
                       <div class="mt-30 info_form">
                           <el-form ref="form" :rules="rules" :label-position="labelPosition" :model="form" label-width="100px"> 
                               <el-form-item label="案例标题 :" prop="title" style="width: 60%;">
                                    <el-input type="textarea"  v-model="form.title" maxlength="50" clearable></el-input>
                                </el-form-item>
                                 <el-form-item label="案例类别 :" prop="category">
                                    <el-cascader
                                     :options="categoryList"  
                                     :props="optionProps"
                                      v-model="form.category" 
                                      :show-all-levels="false"
                                      style="width:53%;"
                                      @change="onChang()"></el-cascader>								
                                </el-form-item>
                                <p class="case_tig">图片信息，上传图片的格式为，289*162px，1M以内</p>
                                <el-form-item class="poster"   label="案例海报:" style="width: 60%;">
                                   <el-input v-model="form.cover" clearable></el-input>
                                    <el-upload
                                    class="upload-demo"
                                    :headers="{token:token}"
                                    action="/api/zwb/app/oss/public/upload"
                                    :on-success="onSuccess"
                                    :show-file-list="false"
                                    :before-upload="handlePictureCardPreview">
                                    <el-button class="posterBtn" type="primary" size="small">选择图片</el-button>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="关键字 ："  style="width: 60%;">
                                    <el-input v-model="form.keyWord" clearable ></el-input>
                                </el-form-item>
                                <div class="tel"> 
                                    <el-form-item label="案例详情">
                                       <tinymceEditor class="mt-15" v-model="form.content" ref="editor"></tinymceEditor>
                                    </el-form-item>
                                    <el-form-item prop="agree" class="fuck">
                                      <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                                      <div style="margin-left: 5px">
                                        我已阅读并同意《<span class="agree" @click="settChange()">供需信息发布声明</span>》
                                      </div>
                                    </el-form-item>

                                </div>
                                <div class="tel mt-30">
                                    <el-button type="success" @click="submitForm('form')">提交案例</el-button>
                                    <!-- <el-button type="warning" @click="resetForm('ruleForm')">预览资讯</el-button> -->
                                </div>
                           </el-form>
                       </div>
                   </div>

                   <!--发布声明弹框-->
                    <div class="sett_dialog" v-show="dialogVisible">
                      <div class="sett_cox"></div>
                      <div class="sett_dialog_box">
                        <div class="sett_matter">
                          <p class="sett_title">供需信息发布声明</p>
                          <p class="sett_jitr">
                            <span v-if="!isImg">{{ time }}s</span>
                            <img
                              v-show="isImg"
                              src="../../assets/images/sign.png"
                              @click.prevent="onText()"
                            />
                          </p>
                        </div>
                        <div class="sett_desc" v-html="issueStatement.des"></div>
                      </div>
                    </div>

                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getToken} from '@/utils/auth'
import {getDict,agreement} from "@/api/coment";
import {addRelease ,eidRelease,exampleInfo} from "@/api/company"
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import paletteBar from '../../common/paletteBar'
import contTitle from '../../common/contTitle'
import tinymceEditor from '../../common/tinymceEditor.vue'
export default {
  components:{
      sidebar,companySide,commBanner,titleHead,paletteBar,contTitle,tinymceEditor
  }, 
  data(){
      return{
        headTitle:'企业案列',
        contTitle:'企业基本信息',
        contTitle1:'企业案列',
        obj:{
           title:'企业案列',   
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9
        },
        paletteObj:{
            paletteTitle:'企业案列',
            paletteName:'添加案列',
            paletteCount:3,
            paletteText:'删除案列',
            isShow:false,
            isDelete:true
        },
        form:{
            title:'',
            category:'',
            cover:'',
            // keyWord:'',
            content:"",
            userid:'',
            agree:''
        },
        rules:{
            title:[
              { required: true, message: '请输入案例标题', trigger: 'blur' },
            ],
            category:[
                { required: true, message: '请选择案列类别', trigger: 'change' }
            ],
            cover:[  { required: true, message: '请输入案例海报', trigger: 'blur' },],
            keyWord:[
              { required: true, message: '请输入关键字', trigger: 'blur' },
            ],
            agree: [{ required: true, message: "请接受智污邦发布声明",trigger: "change"}]
        },
        labelPosition:'left',
        categoryList:[],//行业类别
        optionProps:{
          value: 'id',
          label: 'name',
          children: 'children'
        },
        token:getToken(),
        isTag:true,
        industry_type:'',
        isButton:false,
        id:'',
        dialogVisible:false,
        time:10,
        isImg:false,
        issueStatement:false
      }
  },
  created(){
      this.getCailter();
      this.getAgreement();
      this.form.userid = this.$store.state.user.userInfo.data.userId;
      // this.categoryList = JSON.parse(localStorage.getItem('categoryList'))[0].children;
      if(this.$store.state.user.userInfo.data.status == 1){
          this.isTag = false;
      }
      if(this.$route.query.id){
        this.id = this.$route.query.id;
        this.getExampleInfo(this.id); 
      }
   },
  methods:{
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
			   if(this.id){
            this.getEdit(); 
          }else{
           this.getAdd();
          }
          } else {
            return false;
          }
        });
      },
     //文件上传成功后，返回
      onSuccess(res){
          if(res.code ==0){
            this.$message({
              message:'上传成功！',
              type: 'success',
            });
           this.form.cover = res.url;
         }
      },
     //文件上传前，调用
      handlePictureCardPreview(file){
        const isLtM = file.size / 1024 / 1024 < 3;
            if(!isLtM){
            this.$message.error('上传文件大小不能超过 3MB!');
            }
        return isLtM;
      },
      onChang(){
        this.form.category = this.form.category[this.form.category.length -1];
      },
	  //获取分类
	   getCailter(){
	   let params={
	     code:this.industry_type
	   };
	   getDict(params).then(res=>{
	     if(res.code ==0){
	       this.categoryList = res.data[0].children;
	     }
	   }).catch(err=>{});
	  },
	  getExampleInfo(id){
		  let params = {id:id}
		 exampleInfo(params).then((res)=>{
			if(res.code == 0){
			  this.form = res.data;
			} 
		 }).catch((err)=>{}) 
	  },
	  getAdd(){		 
		 addRelease(this.form).then((res)=>{
		   if(res.code ==0){
		      this.$message({
		         message:'添加成功！',
		         type: 'success',
		          duration:1000,
		         onClose:()=>{
		             this.$router.push('/corporate_case')
		          }
		      });
		   }
		 }).catch((err)=>{}) 
	  },
	  getEdit(){
		 eidRelease(this.form).then((res)=>{
		   if(res.code ==0){
		      this.$message({
		         message:'编辑成功！',
		         type: 'success',
		          duration:1000,
		         onClose:()=>{
		             this.$router.push('/corporate_case')
		          }
		      });
		   }
		 }).catch((err)=>{}) 
    },
     //查询发布声明
    getAgreement() {
      agreement()
        .then((res) => {
          this.issueStatement = res.page.filter((item) => item.name == "供需信息发布声明")[0];
        })
        .catch((err) => {});
    },
    settChange() {
      this.dialogVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogVisible = false;
    }
  },
}
</script>
<style scoped>
.el-aside{
    height: 100%;
}
.el-form-item{
    text-align: left;
}
.tel{
    text-align: left;
}
.mt-15{
    margin-top: 15px;
}
.m-t-30{
    margin-top: 30px;
}
.mt-20{
    margin-top: 20px;
}
.tips{
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #E28B8B; 
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.info_form>>>.el-input__inner{
    height: 50px;
}
.poster{
  position: relative;
}
 /deep/ .upload-demo{
     position: absolute;
     top: 0;
     right: 0;   
 }
.posterBtn{
     width: 125px;
     height: 50px;
     background: #E5E5E5;   
     font-size: 12px;
     font-family: Microsoft YaHei;
     font-weight: 400;
     color: #9A9A9A;
     border: none;
     line-height: 0;
 }
 /deep/.el-button--success{
     width: 114px;
     height: 40px;
     background: #3CBB36;
     border-radius: 3px;
     border: none;
     line-height: 0;
 }
  /deep/.el-button--warning{
    width: 114px;
    height: 40px;
    background: #FF7302;
    border-radius: 3px;
    border: none;
    line-height: 0;
 }
 .text_center{	
	font-size: 14px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
}
.case_tig{
  text-align:left;
  margin-bottom: 15px;
  font-size: 12px;
  color: #999999;
}

/**发布弹框样式 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}

</style>


// WEBPACK FOOTER //
// src/view/company/corporate_caseAdd.vue